
export enum TcInstanceType {
  GRN = "GRN",
  TBB = "TBB",
}
